import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Briefcase, LineChart, Users, Cpu, BookOpen } from "lucide-react"
import { SPACING } from "@/constants/layout"
import { Link } from 'react-router-dom'

const services = [
    {
        title: "Software & Technology",
        description: "Advanced software solutions and digital products for financial services.",
        icon: Cpu
    },
    {
        title: "Investment Services",
        description: "Comprehensive investment strategies and asset management solutions.",
        icon: LineChart
    },
    {
        title: "Professional Services",
        description: "Strategic consulting and research services for business growth.",
        icon: Briefcase
    },
    {
        title: "Insights & Research",
        description: "Industry analysis, market intelligence, and thought leadership.",
        icon: BookOpen
    },
    {
        title: "Community Impact",
        description: "Philanthropic initiatives and community development programs.",
        icon: Users
    }
]

export function ServiceOverview() {
    return (
        <div className={`container mx-auto px-4 ${SPACING.section}`}>
            <div className={`text-center ${SPACING.content}`}>
                <h2 className="text-3xl font-bold tracking-tight">Our Core Services</h2>
                <p className="mt-4 text-lg text-neutral-600 dark:text-neutral-400">
                    Comprehensive solutions across multiple domains
                </p>
            </div>
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                {services.map((service) => {
                    const Icon = service.icon
                    return (
                        <Link to={`/${service.title.toLowerCase().replace(/\s+/g, '-')}`} key={service.title}>
                            <Card variant="bordered">
                                <CardHeader>
                                    <Icon className="h-8 w-8 mb-4" />
                                    <CardTitle>{service.title}</CardTitle>
                                </CardHeader>
                                <CardContent>
                                    <p className="text-neutral-600 dark:text-neutral-400">
                                        {service.description}
                                    </p>
                                </CardContent>
                            </Card>
                        </Link>
                    )
                })}
            </div>
        </div>
    )
} 